import React, { useState } from 'react';
import { MessageCircle, X, Mail, Clock } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingSupport = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring' }}
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 bg-foreground text-background p-4 rounded-full shadow-2xl hover:bg-foreground/90 transition-all hover:scale-110"
        aria-label={isOpen ? "Stäng supportmeny" : "Öppna supportmeny"}
      >
        {isOpen ? (
          <X className="h-6 w-6" aria-hidden="true" />
        ) : (
          <MessageCircle className="h-6 w-6" aria-hidden="true" />
        )}
      </motion.button>

      {/* Support Card */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            className="fixed bottom-24 right-6 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 w-80"
          >
            <div className="p-4 bg-foreground text-background rounded-t-lg">
              <h3 className="font-semibold text-lg">Kontakta oss</h3>
              <p className="text-sm mt-1 opacity-90">
                Vi hjälper dig gärna!
              </p>
            </div>

            <div className="p-4 space-y-3">
              <a 
                href="mailto:info@dekalio.nu"
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-200"
              >
                <div className="bg-purple-100 p-2 rounded-full">
                  <Mail className="h-4 w-4 text-purple-600" />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-sm text-gray-900">Skicka email</p>
                  <p className="text-xs text-gray-500">Svarar inom 2h</p>
                </div>
              </a>

              <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
                <Clock className="h-4 w-4 text-gray-600 mt-0.5" />
                <div>
                  <p className="font-medium text-xs text-gray-900 mb-1">Öppettider</p>
                  <p className="text-xs text-gray-600">Mån-Fre: 09:00 - 17:00</p>
                  <p className="text-xs text-gray-600">Lör-Sön: Stängt</p>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingSupport;
